export default __webpack_public_path__ + "static/media/links.40552cee.svg";